module.exports = __webpack_public_path__ + "img/20210510.834d5ffb.gif";